const subscribers = {};

/**
 * Subscribe to an event
 * @param {string} eventName - The event name
 * @param {function} callback - The callback function
 * @returns {function} - The function to unsubscribe
 * @example
 * connectedCallback() {
 *   this.unsubscribe = subscribe('eventname', (data) => console.log('Event triggered', data));
 * }
 *
 * disconnectedCallback() {
 *   this.unsubscribe();
 * }
 */
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) subscribers[eventName] = [];

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
  };
}

/**
 * Publish an event
 * @param {string} eventName - The event name
 * @param {any} data - The data to pass to the callback
 * @example
 * publish('eventname', 'Hello world!');
 * publish('eventname', { message: 'Hello world!' });
 * publish('eventname', ['Hello', 'world!']);
 * publish('eventname', 42);
 * publish('eventname');
 */
function publish(eventName, data) {
  if (subscribers[eventName])
    subscribers[eventName].forEach((callback) => {
      // Kopstorm: one failing subscriber may not abort the others (variant change error).
      try {
        callback(data);
      } catch (error) {
        console.error(error);
      }
    });
}

// Simply call the functions to prevent Rollup tree shaking
subscribe(undefined, () => undefined);
publish(undefined, () => undefined);
